import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  
  return (
    <div style={{
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      maxWidth: '320px',
      position: 'relative'
    }}>
      <Handle
        type="target"
        position="left"
        style={{
          background: "#f97316",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      
      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#f97316' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <div style={{ 
          width: "18px", 
          height: "18px", 
          backgroundColor: "#f97316",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "10px",
          fontWeight: "bold"
        }}>
          G
        </div>
        <div style={{ color: "#111827", fontSize: "14px", fontWeight: 600 }}>
          Groq
        </div>
      </div>
      
      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
        Groq AI Assistant
      </div>
      
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#f97316",
          width: "12px",
          height: "12px",
          top: "50%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
